import SeoSellerContent from './SeoSellerContent.vue'

export default SeoSellerContent
